import { render, staticRenderFns } from "./ArtBuyer.vue?vue&type=template&id=49fa037e&lang=html"
import script from "./ArtBuyer.vue?vue&type=script&lang=js"
export * from "./ArtBuyer.vue?vue&type=script&lang=js"
import style0 from "./ArtBuyer.vue?vue&type=style&index=0&id=49fa037e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports